import SitefinityApiClient from 'utils/SitefinityApiClient';

// ------------------------------------
// Page/Site Resources
// ------------------------------------

// here you should place all methods that your react containers will use to interact with the API

// sends a structure that resembles a ProductDto so the API can properly parse it
export const createProductOnSitefinity = (product, referer) => (
  SitefinityApiClient.post('products', {
    product: {
      Id: product.ProductID,
      Marketing: {
        Title: product.Title,
        DisplayName: product.DisplayName,
        SubTitle: product.Subtitle,
        Description: product.ProductDescription,
        PackageGridTitle: product.PackageGridTitle,
        PackageGridSubtitle: product.PackageGridSubtitle,
        StructuredData: {
          Brand: product.Brand,
          Organization: product.Organization,
        },
        CardProduct: {
          Heading: product.Heading,
          Content: product.Content,
          ApprovalText: product.ApprovalText,
          SkillLevel: product.SkillLevel || null,
        },
        Categories: product.Categories && product.Categories.split(','),
        PackageTabProductCategory: product.PackageTabProductCategory && {
          Title: product.PackageTabProductCategory,
        },
        ProductSpecifications: product.ProductSpecifications &&
          product.ProductSpecifications.split(',')
            .map((i) => ({ Key: i.split('||')[0] || '', Value: i.split('||')[1] || '' })),
        ShortDescription: product.ShortDescription,
        DisplayConfiguration: product.DisplayConfiguration,
      },
    },
    referer,
  }));

export const abortAllPendingRequests = () => SitefinityApiClient.abortAll();

export const wasRequestCancelled = (thrown) => SitefinityApiClient.isCancel(thrown);

export default {
  createProductOnSitefinity,
  abortAllPendingRequests,
  wasRequestCancelled,
};
